import { showUserDisplayName } from "../../../../lib/userUtils";

/* eslint-disable no-mixed-operators */
const getTestCaseFieldName = (eventEntity) => {
  switch (eventEntity) {
    case 'name': return 'Description';
    case 'objective': return 'Objective';
    case 'preCondition': return 'Pre-Condition';
    case 'technologyLayer': return 'Technology Layer';
    case 'isAutomated': return 'Is Automated';
    case 'labels': return 'Label';
    case 'testSuites': return 'Test Suites';
    case 'reasonForNotAutomated': return 'Reason For Not Automated';
    case 'automationMethod': return 'Automation Method';
    case 'automatedBy': return 'Automated By';
    case 'automationStatus': return 'Automation Status';
    case 'isAutomationNeeded': return 'Candidate For Automation';
    case 'automationCountry': return 'Automation Country';
    case 'notAutomatedCategory': return 'Not Automated Category';
    case 'notAutomatedReason': return 'Not Automated Reason';
    case 'notAutomatedSubCategory': return 'Not Automated Sub Category';
    default: return <span className="text-capitalize">{eventEntity}</span>;
  }
};

const getTestStepFieldName = (eventEntity) => {
  switch (eventEntity) {
    case 'teststep-step': return 'Step';
    case 'teststep-testData': return 'Test Data';
    case 'teststep-expectedResult': return 'Expected Result';
    case 'teststep-uri': return 'URI';
    case 'teststep-attachment': return 'Teststep Attachment';
    default: return <span className="text-capitalize">{eventEntity}</span>;
  }
};

export const getUpdateInfo = (item, statuses, priorities, users, modules, labels, testSuites, fieldConfigs) => {
  const { event_type, event_entity: eventEntity, old_value: oldValueRaw, new_value: newValueRaw } = item;
  let oldValue = oldValueRaw;
  let newValue = newValueRaw;

  if (oldValue === newValue && event_type !== 'UPDATED_TEST_STEP') return null;

  if (['REMOVED_TEST_STEP', 'ADDED_TEST_STEP', 'REMOVED_ATTACHMENT_TESTCASE'].includes(event_type)) {
    return <p>{newValue}</p>;
  }

  // if (['UNARCHIVED_TEST_CASE', 'ARCHIVED_TEST_CASE', 'REMOVED_ATTACHMENT_TESTCASE'].includes(event_type)) {
  //   return null;
  // }

  if (['ADDED_ATTACHMENT_TESTCASE', 'REMOVED_ATTACHMENT_TESTSTEP'].includes(event_type) && newValue.includes('@')) {
    return (
      <p>{newValue.split('@')[1] || ""}</p>
    );
  }

  if (event_type === 'ADDED_ATTACHMENT_TESTSTEP' && newValue.includes('@')) {
    return (
      <p>{newValue.split('@')[2] || ""}</p>
    );
  }

  // if (event_type === 'UPDATED_TEST_STEP') {
  //   return (
  //     <tr>
  //       <td>{getTestStepFieldName(eventEntity)}</td>
  //       <td>{oldValue?.length > 200 ? `${oldValue?.slice(0, 200)}...` : oldValue}</td>
  //       <td>{newValue?.length > 200 ? `${oldValue?.slice(0, 200)}...` : oldValue}</td>
  //     </tr>
  //   );
  // }

  const findCategoryById = (configs, id) =>
    configs?.find(c => c.id === id);

  const findSubCategoryById = (configs, subId) => {
    for (const cat of configs || []) {
      const sub = cat.subCategories?.find(s => s.id === subId);
      if (sub) return sub;
    }
    return null;
  };


  if (event_type === 'UPDATED_TEST_CASE') {
    switch (eventEntity) {
      case 'status':
        oldValue = statuses?.find((status) => status.id === oldValue)?.name || oldValue;
        newValue = statuses?.find((status) => status.id === newValue)?.name || newValue;
        break;
      case 'priority':
        oldValue = priorities?.find((priority) => priority.id === oldValue)?.name || oldValue;
        newValue = priorities?.find((priority) => priority.id === newValue)?.name || newValue;
        break;
      case 'owner':
      case 'reviewer':
        oldValue = showUserDisplayName(oldValue, users);
        newValue = showUserDisplayName(newValue, users);
        break;
      case 'automatedBy':
          oldValue = showUserDisplayName(oldValue, users);
          newValue = showUserDisplayName(newValue, users);
          break;
      case 'module':
        oldValue = modules?.find((module) => module.id === oldValue)?.name || oldValue;
        newValue = modules?.find((module) => module.id === newValue)?.name || newValue;
        break;
      case 'labels':
      case 'testSuites': {
        const oldArray = oldValue ? oldValue.split(',') : [];
        const newArray = newValue ? newValue.split(',') : [];
        const lookupList = eventEntity === 'labels' ? labels : testSuites;
        oldValue = oldArray.map((id) => lookupList?.find((item) => item.id === id)?.name).filter(Boolean).join(', ');
        newValue = newArray.map((id) => lookupList?.find((item) => item.id === id)?.name).filter(Boolean).join(', ');
        break;
      }
      case 'notAutomatedCategory': {
        oldValue = findCategoryById(fieldConfigs, oldValue)?.name || oldValue;
        newValue = findCategoryById(fieldConfigs, newValue)?.name || newValue;
        break;
      }

      case 'notAutomatedSubCategory': {
        oldValue = findSubCategoryById(fieldConfigs, oldValue)?.name || oldValue;
        newValue = findSubCategoryById(fieldConfigs, newValue)?.name || newValue;
        break;
      }
      default:
        break;
    }

    return (
      <tr>
        <td>{getTestCaseFieldName(eventEntity)}</td>
        <td>{oldValue || ""}</td>
        <td>{newValue}</td>
      </tr>
    );
  }

  return null;
};

export const getItemText = (item) => {
  const { event_type, new_value: newValue } = item;

  switch (event_type) {
    case 'REMOVED_TEST_STEP': return 'removed a test step.';
    case 'ADDED_TEST_STEP': return 'added a test step.';
    case 'CREATED_TEST_CASE': return 'created this test case.';
    case 'UPDATED_TEST_STEP': return 'updated a test step.';
    case 'UPDATED_TEST_CASE': return 'updated test case details.';
    case 'ARCHIVED_TEST_CASE': return 'archived the test case.';
    case 'UNARCHIVED_TEST_CASE': return 'unarchived the test case.';
    case 'ADDED_ATTACHMENT_TESTCASE': return 'added some attachment(s).';
    case 'REMOVED_ATTACHMENT_TESTCASE': return `removed attachment(s).`;
    case 'ADDED_ATTACHMENT_TESTSTEP':
      return newValue.includes('@') ? `added some attachment(s) to step ${newValue.split('@')[0]}` : 'added some attachment(s).';
    case 'REMOVED_ATTACHMENT_TESTSTEP':
      return newValue.includes('@') ? `removed attachment(s) from step ${newValue.split('@')[0]}` : 'removed an attachment(s).';
    default:
      return '';
  }
};
